import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);
import axios from 'axios'

export default new Vuex.Store({
state: {
  salesforceAccessToken: sessionStorage.getItem('salesforceAccessToken') || '',
  salesforceInstanceUrl: sessionStorage.getItem('salesforceInstanceUrl') || '',
  salesforceUser: JSON.parse(sessionStorage.getItem('salesforceUser')) || null,
  markers: null,
  geoJsonMarkers: null,
  geoJsonUsers: null,
  geoJsonTypes: null,
  geoJsonTypologies: null,
  geoJsonDepartements: null,
  geoJsonRegions: null,
  geoJsonRegionsSF: null
},
mutations: {
  salesforceLogged: (state, data) => {
    state.salesforceAccessToken = data.salesforceAccessToken;
    state.salesforceInstanceUrl = data.salesforceInstanceUrl;
    state.salesforceUser = data.salesforceUser;
  },
  salesforceUnlogged: (state) => {
    state.salesforceAccessToken = '';
    state.salesforceInstanceUrl = '';
    state.salesforceUser = null;
  },
  storeMarkers:(state, data) => {
    state.markers = data;
    localStorage.setItem('markers', JSON.stringify(data));
  },
  unstoreMarkers:(state) => {
    state.markers = [];
  },
  setGeoJsonMarkers(state, data) {
    state.geoJsonMarkers = data;
    localStorage.setItem('geoJsonMarkers', JSON.stringify(data));
  },
  setGeoJsonUsers(state, data) {
    state.geoJsonUsers = data;
    localStorage.setItem('geoJsonUsers', JSON.stringify(data));
  },
  setGeoJsonTypes(state, data) {
    state.geoJsonTypes = data;
    localStorage.setItem('geoJsonTypes', JSON.stringify(data));
  },
  setGeoJsonTypologies(state, data) {
    state.geoJsonTypologies = data;
    localStorage.setItem('geoJsonTypologies', JSON.stringify(data));
  },
  setGeoJsonDepartements(state, data) {
    state.geoJsonDepartements = data;
    localStorage.setItem('geoJsonDepartements', JSON.stringify(data));
  },
  setGeoJsonRegions(state, data) {
    state.geoJsonRegions = data;
    localStorage.setItem('geoJsonRegions', JSON.stringify(data));
  },
  setGeoJsonRegionsSF(state, data) {
    state.geoJsonRegionsSF = data;
    localStorage.setItem('geoJsonRegionsSF', JSON.stringify(data));
  },
  setAllGeoJsoFromLocalStorage(state) {
    state.markers = JSON.parse(localStorage.getItem('markers'));
    state.geoJsonMarkers = JSON.parse(localStorage.getItem('geoJsonMarkers'));
    state.geoJsonUsers = JSON.parse(localStorage.getItem('geoJsonUsers'));
    state.geoJsonTypes = JSON.parse(localStorage.getItem('geoJsonTypes'));
    state.geoJsonTypologies = JSON.parse(localStorage.getItem('geoJsonTypologies'));
    state.geoJsonDepartements = JSON.parse(localStorage.getItem('geoJsonDepartements'));
    state.geoJsonRegions = JSON.parse(localStorage.getItem('geoJsonRegions'));
    state.geoJsonRegionsSF = JSON.parse(localStorage.getItem('geoJsonRegionsSF'));
  },
  unstoreAllGeoJson(state) {
    state.markers = null;
    state.geoJsonMarkers = null;
    state.geoJsonUsers = null;
    state.geoJsonTypes = null;
    state.geoJsonTypologies = null;
    state.geoJsonDepartements = null;
    state.geoJsonRegions = null;
    state.geoJsonRegionsSF = null;

    localStorage.removeItem('markers');
    localStorage.removeItem('geoJsonMarkers');
    localStorage.removeItem('geoJsonUsers');
    localStorage.removeItem('geoJsonTypes');
    localStorage.removeItem('geoJsonTypologies');
    localStorage.removeItem('geoJsonDepartements');
    localStorage.removeItem('geoJsonRegions');
    localStorage.removeItem('geoJsonRegionsSF');
    localStorage.clear();
  }
},
actions: {
  async salesforceLogin(context, data) {
    try {
      let response = await axios.get(data.salesforceInstanceUrl + '/services/data/v44.0/chatter/users/me', {
        headers: {
          Accept: 'application/json',
          Authorization: 'Bearer ' + data.salesforceAccessToken
        }
      })
      let user = response.data;

      sessionStorage.setItem('salesforceAccessToken', data.salesforceAccessToken);
      sessionStorage.setItem('salesforceInstanceUrl', data.salesforceInstanceUrl);
      sessionStorage.setItem('salesforceUser', JSON.stringify(user));

      let commit = {
        salesforceAccessToken: data.salesforceAccessToken,
        salesforceInstanceUrl: data.salesforceInstanceUrl,
        salesforceUser: user
      }
      context.commit('salesforceLogged', commit);
    } catch (e) {
      console.error(e);
    }
  },
  salesforceLogout: (context) => {
    sessionStorage.removeItem('salesforceAccessToken');
    sessionStorage.removeItem('salesforceInstanceUrl');
    sessionStorage.removeItem('salesforceUser');
    context.commit('salesforceUnlogged');
  },
  async storeGeoJsonDepartements (context) {
    let imp = await import('./data/france-geojson-raw/departements-version-simplifiee.json');
    context.commit('setGeoJsonDepartements', imp.default);
  },
  async storeGeoJsonRegions (context) {
    let imp = await import('./data/france-geojson-raw/regions-version-simplifiee.json');
    context.commit('setGeoJsonRegions', imp.default);
  }
},
getters: {
  salesforceAccessToken: state => state.salesforceAccessToken,
  salesforceInstanceUrl: state => state.salesforceInstanceUrl,
  salesforceUser: state => state.salesforceUser,
  isSalesforceAuthenticated: state => !!state.salesforceUser,
  markers: state => state.markers,
  geoJsonMarkers: state => state.geoJsonMarkers,
  geoJsonUsers: state => state.geoJsonUsers,
  geoJsonTypes: state => state.geoJsonTypes,
  geoJsonTypologies: state => state.geoJsonTypologies,
  geoJsonDepartements: state => state.geoJsonDepartements,
  geoJsonRegions: state => state.geoJsonRegions,
  geoJsonRegionsSF: state => state.geoJsonRegionsSF
}
});